import * as React from 'react';
import Svg, {
    G,
    Path,
    Defs,
    LinearGradient,
    Stop,
    ClipPath,
    Ellipse,
    Circle,
} from 'react-native-svg';
import { BODY_PARTS, BodyPartsSvgProps } from '../../../components/screens/Game/bodyPartsControls/bodyPartsConstants';
import { BODY_PARTS_SVG_BUTTON_TYPES, BodyPartSvgButton } from '../../../components/helperComponents/BodyPartSvgButton';
/* SVGR has dropped some elements not supported by react-native-svg: filter */


function BodyTypesSVG_arm({ onPress, highlightedParts }: BodyPartsSvgProps) {
    const [active, setActive] = React.useState<BODY_PARTS | undefined>();

    return (
        <Svg
            style={{ width: '100%', height: '100%' }}
            viewBox="0 0 194 204"
            fill="none"
        >
            <G id="Arm">
                <G id="Arm_2">
                    <G id="Arm_3" clipPath="url(#clip0_5385_8392)">
                        <G id="Group 27619">
                            <G id="Group 27586">
                                <Path
                                    id="Vector"
                                    d="M180.197 48.24c-53.187 8.428-25.801 7.8-25.163 22.217.181 13.9-.545 18.662-.023 27.197.102 7.876 2.571 38.613 2.551 47.327 6.486 3.39 59.848 1.73 60.808-.784 0 0 2.75-40.83 3.174-48.25-.009-8.178 5.482-31.982 2.583-42.092-4.114-1.065-6.59-1.734-9.519-2.131-14.924-2.24-13.393-4.304-34.411-3.484z"
                                    fill="#915548"
                                />
                                <Path
                                    id="Vector_2"
                                    d="M216.471 144.205c-2.292 4.151-29.655 4.071-40.225 3.852-7.406-.083-15.04-1.773-17.16-2.732 0 0-.683-12.515-.767-14.626-.053-1.053-.301-5.451-.423-7.816 0 0-.022-3.625-.422-8.978-.4-5.352-1.189-30.856-2.291-42.902-2.011-19.9-8.929-15.354 17.185-20.26 18.18-4.525 50.613 4.034 50.613 4.034-.208 15.36-6.51 89.428-6.51 89.428z"
                                    fill="url(#paint0_linear_5385_8392)"
                                />
                                <Path
                                    id="Vector 29"
                                    d="M155.969 80.9c-.128-2.274-.085-3.79-.085-3.79.028 1.29.056 2.552.085 3.79.355 6.293 2.022 18.39 9.541 20.211 3.284.796-4.262 2.556-5.608 6.509-2.78 8.169 1.392 18.052.555 26.64-.517 5.301-1.554 11.885-1.554 11.885-1.494-24.551-2.334-39.625-2.934-65.245z"
                                    fill="url(#paint1_linear_5385_8392)"
                                />
                                <Path
                                    id="Vector 30"
                                    d="M187.043 92.461c-.677 4.88-2.68 7.44-7.649 9.019-.228.073-.173.458.066.452l16.039-.373c.239-.005.277-.395.047-.458-4.892-1.348-6.989-3.871-7.98-8.657-.049-.236-.489-.221-.523.017z"
                                    fill="#DD976A"
                                />
                                <Ellipse
                                    id="Ellipse 13"
                                    cx={169.111}
                                    cy={92.7723}
                                    rx={2.42566}
                                    ry={1.49792}
                                    fill="#D4885F"
                                />
                                <Path
                                    id="Vector_3"
                                    d="M179.014 48.184l.872 1.715.853 1.716.795 1.735c.261.581.504 1.173.727 1.783a12.878 12.878 0 01-1.134-1.57 18.771 18.771 0 01-.911-1.706 23.649 23.649 0 01-.698-1.803c-.214-.61-.359-1.24-.504-1.87z"
                                    fill="#915548"
                                />
                                <Path
                                    id="Vector_4"
                                    d="M169.166 56.316c1.246.455 2.602.722 3.987.785 1.379.077 2.764.077 4.143 0a19.2 19.2 0 014.26.184c1.361.33 2.592.906 3.584 1.677a15.215 15.215 0 00-3.779-1.193 24.992 24.992 0 00-4.091 0 27.247 27.247 0 01-4.26-.184c-1.398-.19-2.715-.625-3.844-1.27z"
                                    fill="#915548"
                                />
                            </G>
                            <G id="Group 27555">
                                <G id="Group 27539">
                                    <Path
                                        id="Vector_5"
                                        d="M129.678 109.775c-1.424-3.667-2.792-7.65-4.123-11.364-3.089-8.44-5.677-17.105-8.05-25.704-1.982-5.025-7.11-3.1-10.237-.242-1.396 1.2-2.876 2.885-2.587 4.942 1.005 5.947 1.787 11.996 2.448 18.008.66 6.012.679 12.098 1.954 18.259 1.117 6.235 4.532 11.605 7.789 16.975.875 1.219 1.638 2.68 2.951 3.546 1.982 1.07 4.169.661 6.151.139 3.295-.735 5.516-3.387 7.638-5.677.623-.651-2.017-1.6-2.166-3.266-.204-2.345.345-3.825.158-6.794a36.273 36.273 0 00-1.926-8.822z"
                                        fill="#915548"
                                    />
                                    <Path
                                        id="Vector_6"
                                        d="M133.112 127.578c-1.473 1.59-2.819 2.893-4.898 4.126-2.317 1.389-6.903 2.468-8.552.158-1.573-1.861-3.629-5.09-7.138-11.745-3.508-6.654-3.564-16.928-4.253-23.498-.689-6.57-1.861-15.319-2.792-20.112-.605-3.35 7.073-9.306 10.014-5.062a5.68 5.68 0 01.93 2.177c1.694 7.995 9.568 30.879 11.503 34.751a67.185 67.185 0 014.654 15.495c.176 1.452.976 3.009.532 3.71z"
                                        fill="url(#paint2_linear_5385_8392)"
                                    />
                                    <Path
                                        id="Vector_7"
                                        style={{
                                            mixBlendMode: 'darken',
                                        }}
                                        d="M133.309 127.535c-1.32 1.501-3.168 2.909-4.88 4.104-3.394 1.907-7.178 2.223-8.751.362-1.573-1.861-3.63-5.091-7.138-11.745-3.509-6.654-3.565-16.928-4.253-23.499-.689-6.57-1.862-15.318-2.792-20.11-.605-3.351 7.073-9.307 10.013-5.064-1.796 2.578-3.992 5.37-3.992 5.37-2.047 2.541-2.95 3.444-2.047 10.814.902 7.371 2.047 19.153 2.978 25.23.93 6.077 4.141 11.773 6.207 15.133 2.066 3.359 4.532 2.717 6.859 2.457 1.2-.131 4.954-2.52 7.7-5.638.186 1.387.449 2.232.096 2.586z"
                                        fill="url(#paint3_linear_5385_8392)"
                                    />
                                    <Path
                                        id="Vector_8"
                                        d="M129.003 49.479c-3.304-2.308-7.073 3.648-7.064 6.403a3.361 3.361 0 01-1.116 2.54 9.895 9.895 0 01-1.713 1.704 15.82 15.82 0 01-1.573-4.877c-.186-1.712-.977-11.642-1.116-14.676-.084-1.722-.512-2.904-1.322-3.593a2.647 2.647 0 00-2.047-.614c-2.587.28-2.587 3.723-2.587 5.193 0 1.861-.084 6.775-.149 9.614-1.052-3.611-3.621-12.704-4.142-14.118-1.247-3.36-3.052-3.639-4.355-3.285-2.792.763-2.076 3.787-1.796 4.923.363 1.545 3.769 13.625 4.318 15.765a.465.465 0 01-.102.14c-.373-.652-1.257-2.318-2.187-4.077-3.193-5.425-4.654-11.233-8.525-9.38-.93.54-1.862 1.86-.726 4.81.54 1.462 5.025 11.03 5.863 12.537a.59.59 0 010 .065c-.633-.791-1.74-2.243-2.792-3.555-2.382-2.792-3.806-6.394-7.12-4.411-1.414 1.237-.25 3.443.13 4.169.755 1.452 4.728 7.445 5.687 8.767 2.122 3.238 2.494 6.319 3.974 9.548 1.228 3.62 3.267 7.976 8.069 8.376 2.354 0 4.346-4.011 5.351-4.654 1.861.261 4.532 2.02 6.3.987a8.807 8.807 0 002.792-2.317 46.108 46.108 0 003.825-7.064 33.306 33.306 0 011.275-4.132c.884-2.038 1.936-4.141 2.15-6.328.214-1.79.674-3.54 1.368-5.203a2.792 2.792 0 00-.67-3.257z"
                                        fill="#915548"
                                    />
                                    <Path
                                        id="Vector_9"
                                        d="M128.621 52.197a20.303 20.303 0 00-1.47 5.584c-.195 1.991-1.219 4.048-2.057 5.974a33.734 33.734 0 00-1.321 4.225 45.972 45.972 0 01-3.676 6.794c-.987 1.47-5.324 4.011-7.939 3.276-.493.41-4.243 2.96-6.793 2.01a8.691 8.691 0 01-4.812-5.063c-.651-1.796-2.122-5.295-3.043-8.133a14.83 14.83 0 00-1.992-4.04c-.93-1.284-4.876-7.258-5.584-8.608-.707-1.35-.93-2.243-.428-2.708a1.945 1.945 0 012.56.568c.837.93 5.165 6.738 6.058 7.761.521.596 1.108.158 1.433-.465a1.48 1.48 0 00.14-1.312c-.456-.708-5.267-10.926-5.844-12.47-.512-1.369-.661-2.57 0-3.193.076-.08.164-.15.26-.205.93-.512 1.796-.065 2.634 1.098.837 1.164 5.844 10.852 6.617 12.099.437.744 1.144.567 1.638.12a1.429 1.429 0 00.502-1.19c-.195-.931-3.899-14.025-4.346-15.887-.419-1.721-.437-2.95.67-3.424l.298-.103c1.414-.39 2.317.829 2.959 2.569.643 1.74 4.3 14.825 4.654 15.923a.763.763 0 00.34.494.764.764 0 00.59.102.854.854 0 00.763-.605c.065-.512.214-9.446.214-11.82 0-2.372.298-3.787 1.406-4.01a.24.24 0 01.139 0c1.201-.112 1.945.865 2.048 3.099.149 3.062.93 12.945 1.126 14.75a15.131 15.131 0 001.303 4.393c.27.633.586 1.322.93 2.085a11.178 11.178 0 002.96-2.532 4.701 4.701 0 001.507-3.406 7.718 7.718 0 013.211-5.388c.856-.596 1.526-.512 1.945-.158a1.608 1.608 0 01.4 1.796z"
                                        fill="url(#paint4_linear_5385_8392)"
                                    />
                                    <Path
                                        id="Vector_10"
                                        style={{
                                            mixBlendMode: 'darken',
                                        }}
                                        d="M93.89 45.544c-.511-1.367-.66-2.568 0-3.192.04 1.455.391 2.883 1.034 4.188 1.219 2.876 3.238 7.055 4.03 8.85.79 1.797 1.991 3.137.688 3.937a1.48 1.48 0 00.14-1.312c-.503-.707-5.314-10.926-5.891-12.47z"
                                        fill="url(#paint5_linear_5385_8392)"
                                    />
                                    <Path
                                        id="Vector_11"
                                        style={{
                                            mixBlendMode: 'darken',
                                        }}
                                        d="M101.159 38.425c-.419-1.721-.438-2.95.67-3.424a6.874 6.874 0 00.242 3.974c.502 1.59 2.159 8.208 2.596 10.237.438 2.028 1.797 5.686.503 6.263a.364.364 0 01-.168 0 1.43 1.43 0 00.503-1.191c-.195-.875-3.899-13.997-4.346-15.859z"
                                        fill="url(#paint6_linear_5385_8392)"
                                    />
                                    <Path
                                        id="Vector_12"
                                        style={{
                                            mixBlendMode: 'darken',
                                        }}
                                        d="M112.158 78.05c-.493.41-4.243 2.96-6.793 2.01a8.692 8.692 0 01-4.812-5.062c-.651-1.796-2.122-5.295-3.043-8.134a14.831 14.831 0 00-1.992-4.039c-.93-1.284-4.876-7.259-5.584-8.608-.707-1.35-.93-2.243-.428-2.709a8.637 8.637 0 001.192 2.876c1.08 1.861 3.527 5.398 4.653 6.906a17.571 17.571 0 012.736 5.332c.865 2.448 2.662 7.846 4.03 9.716 1.368 1.87 4.858 4.793 10.041 1.713z"
                                        fill="url(#paint7_linear_5385_8392)"
                                    />
                                    <Path
                                        id="Vector_13"
                                        style={{
                                            mixBlendMode: 'darken',
                                        }}
                                        d="M110.781 54.02a.215.215 0 01-.131 0 .854.854 0 00.764-.605c.065-.512.214-9.446.214-11.82 0-2.372.297-3.787 1.405-4.01-.521.27-.931 2.447-.931 5.965.075 3.816-.214 7.445-.214 8.488 0 1.042-.242 1.908-1.107 1.982z"
                                        fill="url(#paint8_linear_5385_8392)"
                                    />
                                    <Path
                                        id="Vector_14"
                                        style={{
                                            mixBlendMode: 'darken',
                                        }}
                                        d="M128.268 50.371c-.996-.102-2.364 1.173-3.295 2.569a7.942 7.942 0 00-1.293 3.955 9.308 9.308 0 01-2.662 4.393c-1.014.79-3.239 1.805-4.653 2.792-1.415.986-4.03 3.666-4.532 5.035-.149-3.379 2.298-6.04 4.029-7.557a14.607 14.607 0 001.862-1.806c.269.633.586 1.322.93 2.085a11.177 11.177 0 002.96-2.531 4.704 4.704 0 001.507-3.406 7.718 7.718 0 013.211-5.389c.838-.55 1.508-.493 1.936-.14z"
                                        fill="url(#paint9_linear_5385_8392)"
                                    />
                                    <Path
                                        id="Vector_15"
                                        d="M96.96 62.722a16.241 16.241 0 012.886-4.42 13.963 13.963 0 014.327-3.146 17.203 17.203 0 015.147-1.406c.877-.105 1.76-.154 2.643-.149.884 0 1.768.065 2.643.14-.875.065-1.75.195-2.615.298-.866.102-1.712.242-2.559.41a22.675 22.675 0 00-4.914 1.47 14.829 14.829 0 00-4.253 2.792 20.833 20.833 0 00-3.304 4.01z"
                                        fill="#915548"
                                    />
                                    <Path
                                        id="Vector_16"
                                        d="M111.926 68.382a10.72 10.72 0 011.638-3.257 11.167 11.167 0 012.652-2.569c1.024-.698 2.094-1.247 3.108-1.861.505-.3.987-.636 1.443-1.005a6.294 6.294 0 001.228-1.303 5.58 5.58 0 01-.93 1.563 9.06 9.06 0 01-1.368 1.238c-.987.744-2.048 1.322-3.025 1.973a13.068 13.068 0 00-2.68 2.28 14.105 14.105 0 00-2.066 2.94z"
                                        fill="#915548"
                                    />
                                    <Path
                                        id="Vector_17"
                                        d="M107.57 69.222a6.05 6.05 0 012.085 1.22 6.278 6.278 0 012.168 4.215 5.447 5.447 0 01-.307 2.299c.011-.77-.064-1.537-.223-2.29a8.317 8.317 0 00-.745-2.103 8.435 8.435 0 00-1.256-1.861 9.56 9.56 0 00-1.722-1.48z"
                                        fill="#915548"
                                    />
                                </G>
                                <G id="Group 27553">
                                    <Path
                                        id="Vector_18"
                                        d="M155.057 53.788c-16.292-.862-23.953 26.277-25.611 33.552-3.701 14.314-3.073 17.609-2.372 25.287.723 6.987-12.599 15.134-6.157 19.588 6.485 3.389 10.801-.615 13.19-3.857 3.776-5.12 7.186-11.291 10.237-16.481 7.696-12.946 19.158-57.033 10.713-58.09z"
                                        fill="#915548"
                                    />
                                    <Path
                                        id="Vector_19"
                                        d="M144.927 108.275c-2.137 4.63-8.293 13.227-10.859 17.862-.499 1.074-1.232 1.944-2.12 2.516a4.553 4.553 0 01-2.916.726c-1.704-.255-.309-1.837-1.836-2.874 0 0-.629-2.626-1.029-7.979-.4-5.353.876-16.391 4.089-30.116 2.912-14.052 11.21-33.496 25.507-34.437 2.752.377 2.585 6.693 2.191 11.776-.241 3.116-1.033 8.74-1.966 11.585-.419 1.274-1.435 2.992-1.767 4.228-4.839 19.082-7.332 22.014-9.294 26.713z"
                                        fill="url(#paint10_linear_5385_8392)"
                                    />
                                </G>
                            </G>
                        </G>
                        <G id="-">
                            <G id="Group 27570">
                                <Path
                                    id="Vector_20"
                                    d="M129.588 108.912c-1.424-3.667-2.792-7.65-4.123-11.363-3.089-8.441-5.677-17.106-8.05-25.705-1.982-5.025-7.11-3.099-10.237-.242-1.396 1.2-2.875 2.885-2.587 4.942 1.005 5.947 1.787 11.996 2.448 18.008.66 6.012.679 12.098 1.954 18.259 1.117 6.236 4.532 11.605 7.79 16.975.874 1.219 1.637 2.68 2.95 3.546 1.982 1.07 4.169.661 6.151.14 3.295-.736 5.516-3.388 7.638-5.677.623-.652-2.017-1.601-2.166-3.267-.204-2.345.345-3.825.159-6.794a36.322 36.322 0 00-1.927-8.822z"
                                    fill="#915548"
                                />
                                <Path
                                    id="Vector_21"
                                    d="M133.022 126.715c-1.473 1.591-2.819 2.893-4.898 4.126-2.317 1.389-6.903 2.468-8.552.158-1.572-1.861-3.629-5.09-7.138-11.744-3.508-6.654-3.564-16.929-4.253-23.5-.688-6.57-1.861-15.318-2.792-20.11-.605-3.35 7.073-9.307 10.014-5.063.46.652.777 1.394.931 2.178 1.693 7.994 9.567 30.878 11.502 34.75a67.2 67.2 0 014.654 15.495c.176 1.452.976 3.009.532 3.71z"
                                    fill="url(#paint11_linear_5385_8392)"
                                />
                                <Path
                                    id="Vector_22"
                                    style={{
                                        mixBlendMode: 'darken',
                                    }}
                                    d="M133.219 126.672c-1.319 1.501-3.167 2.909-4.88 4.105-3.394 1.906-7.178 2.223-8.751.361-1.573-1.861-3.63-5.09-7.138-11.744-3.509-6.655-3.564-16.929-4.253-23.5-.689-6.57-1.861-15.318-2.792-20.11-.605-3.35 7.073-9.307 10.014-5.063-1.797 2.578-3.993 5.37-3.993 5.37-2.047 2.54-2.95 3.443-2.047 10.814.902 7.37 2.047 19.152 2.978 25.229.93 6.078 4.141 11.773 6.207 15.133 2.066 3.359 4.532 2.717 6.859 2.457 1.201-.131 4.954-2.52 7.7-5.637.186 1.386.449 2.232.096 2.585z"
                                    fill="url(#paint12_linear_5385_8392)"
                                />
                                <Path
                                    id="Vector_23"
                                    style={{
                                        mixBlendMode: 'darken',
                                    }}
                                    d="M93.8 44.682c-.511-1.368-.66-2.569 0-3.192.04 1.454.392 2.882 1.034 4.188 1.219 2.875 3.239 7.054 4.03 8.85.79 1.796 1.991 3.136.688 3.937a1.478 1.478 0 00.14-1.313c-.503-.707-5.314-10.925-5.891-12.47z"
                                    fill="url(#paint13_linear_5385_8392)"
                                />
                                <Path
                                    id="Vector_24"
                                    style={{
                                        mixBlendMode: 'darken',
                                    }}
                                    d="M101.069 37.563c-.419-1.722-.437-2.95.67-3.425a6.874 6.874 0 00.242 3.974c.503 1.591 2.159 8.208 2.597 10.237.437 2.029 1.796 5.686.502 6.263a.36.36 0 01-.167 0 1.428 1.428 0 00.502-1.191c-.195-.875-3.899-13.997-4.346-15.858z"
                                    fill="url(#paint14_linear_5385_8392)"
                                />
                                <Path
                                    id="Vector_25"
                                    style={{
                                        mixBlendMode: 'darken',
                                    }}
                                    d="M112.068 77.188c-.493.41-4.243 2.96-6.793 2.01a8.692 8.692 0 01-4.812-5.063c-.651-1.796-2.122-5.295-3.043-8.134a14.837 14.837 0 00-1.992-4.039c-.93-1.284-4.876-7.259-5.583-8.608-.708-1.35-.931-2.243-.428-2.708a8.636 8.636 0 001.19 2.875c1.08 1.862 3.528 5.398 4.654 6.906a17.571 17.571 0 012.736 5.332c.866 2.448 2.662 7.846 4.03 9.716 1.368 1.871 4.858 4.793 10.041 1.713z"
                                    fill="url(#paint15_linear_5385_8392)"
                                />
                                <G id="Left hand">
                                    <Path
                                        id="Vector_26"
                                        d="M128.913 48.616c-3.304-2.308-7.073 3.648-7.063 6.403a3.37 3.37 0 01-1.117 2.54 9.864 9.864 0 01-1.713 1.704 15.819 15.819 0 01-1.572-4.877c-.187-1.712-.978-11.642-1.117-14.676-.084-1.722-.512-2.904-1.322-3.592a2.647 2.647 0 00-2.047-.614c-2.587.279-2.587 3.722-2.587 5.193 0 1.86-.084 6.775-.149 9.613-1.052-3.61-3.62-12.703-4.142-14.118-1.247-3.36-3.052-3.639-4.355-3.285-2.792.763-2.075 3.788-1.796 4.923.363 1.545 3.769 13.625 4.318 15.765a.448.448 0 01-.102.14c-.373-.652-1.257-2.318-2.187-4.076-3.193-5.426-4.654-11.233-8.525-9.381-.93.54-1.861 1.861-.726 4.811.54 1.461 5.026 11.028 5.863 12.536a.59.59 0 010 .065c-.633-.791-1.74-2.243-2.792-3.555-2.382-2.792-3.806-6.393-7.12-4.411-1.414 1.238-.25 3.443.131 4.169.754 1.452 4.728 7.445 5.686 8.767 2.122 3.238 2.494 6.319 3.974 9.548 1.229 3.62 3.267 7.976 8.069 8.376 2.354 0 4.346-4.011 5.351-4.653 1.861.26 4.532 2.02 6.301.986a8.804 8.804 0 002.791-2.317 46.013 46.013 0 003.825-7.064 33.306 33.306 0 011.275-4.132c.884-2.038 1.936-4.141 2.15-6.328.214-1.789.675-3.54 1.368-5.203a2.795 2.795 0 00-.67-3.257z"
                                        fill="#915548"
                                    />
                                    <Path
                                        id="Vector_27"
                                        d="M128.532 51.334a20.305 20.305 0 00-1.471 5.584c-.195 1.991-1.219 4.048-2.057 5.974a33.734 33.734 0 00-1.321 4.226 45.88 45.88 0 01-3.676 6.793c-.987 1.47-5.323 4.011-7.939 3.276-.493.41-4.243 2.96-6.793 2.01a8.691 8.691 0 01-4.812-5.062c-.651-1.796-2.122-5.296-3.043-8.134a14.836 14.836 0 00-1.992-4.04c-.93-1.283-4.876-7.258-5.583-8.608-.708-1.349-.931-2.242-.428-2.708a1.945 1.945 0 012.559.568c.837.93 5.165 6.738 6.058 7.761.521.596 1.108.159 1.433-.465a1.48 1.48 0 00.14-1.312c-.456-.707-5.267-10.926-5.844-12.47-.512-1.369-.661-2.57 0-3.193.076-.08.164-.15.26-.205.93-.511 1.796-.065 2.634 1.099.838 1.163 5.844 10.85 6.617 12.098.437.744 1.145.568 1.638.121a1.418 1.418 0 00.502-1.191c-.195-.93-3.899-14.025-4.346-15.886-.419-1.722-.437-2.95.67-3.425l.298-.103c1.415-.39 2.317.829 2.96 2.57.642 1.74 4.299 14.824 4.653 15.922a.763.763 0 00.34.494.764.764 0 00.59.102.854.854 0 00.764-.605c.065-.512.214-9.446.214-11.82 0-2.372.297-3.787 1.405-4.01a.24.24 0 01.139 0c1.201-.112 1.945.865 2.048 3.099.149 3.062.931 12.945 1.126 14.75a15.13 15.13 0 001.303 4.393c.27.633.586 1.322.93 2.085a11.161 11.161 0 002.96-2.531 4.703 4.703 0 001.508-3.407 7.7 7.7 0 013.21-5.388c.857-.596 1.527-.512 1.945-.158a1.613 1.613 0 01.401 1.796z"
                                        fill="url(#paint16_linear_5385_8392)"
                                    />
                                    <Path
                                        id="Vector_28"
                                        style={{
                                            mixBlendMode: 'darken',
                                        }}
                                        d="M110.691 53.157a.212.212 0 01-.13 0 .853.853 0 00.763-.605c.065-.512.214-9.446.214-11.819 0-2.373.298-3.788 1.405-4.011-.521.27-.931 2.447-.931 5.965.075 3.816-.214 7.446-.214 8.488 0 1.042-.242 1.908-1.107 1.982z"
                                        fill="url(#paint17_linear_5385_8392)"
                                    />
                                    <Path
                                        id="Vector_29"
                                        style={{
                                            mixBlendMode: 'darken',
                                        }}
                                        d="M128.178 49.509c-.996-.103-2.364 1.172-3.294 2.568a7.933 7.933 0 00-1.294 3.955 9.308 9.308 0 01-2.662 4.393c-1.014.791-3.238 1.806-4.653 2.792-1.415.987-4.03 3.667-4.532 5.035-.149-3.378 2.298-6.04 4.029-7.557a14.607 14.607 0 001.862-1.806c.27.633.586 1.322.93 2.085a11.161 11.161 0 002.96-2.531 4.702 4.702 0 001.507-3.406 7.719 7.719 0 013.211-5.389c.838-.549 1.508-.493 1.936-.14z"
                                        fill="url(#paint18_linear_5385_8392)"
                                    />
                                    <Path
                                        id="Vector_30"
                                        d="M96.871 61.859a16.238 16.238 0 012.885-4.42 13.954 13.954 0 014.328-3.146 17.196 17.196 0 015.146-1.406c.877-.105 1.76-.154 2.643-.148.884 0 1.768.065 2.643.14-.875.064-1.749.195-2.615.297-.865.102-1.712.242-2.559.41a22.691 22.691 0 00-4.914 1.47 14.829 14.829 0 00-4.253 2.792 20.84 20.84 0 00-3.304 4.01z"
                                        fill="#915548"
                                    />
                                    <Path
                                        id="Vector_31"
                                        d="M111.836 67.52a10.72 10.72 0 011.638-3.258 11.167 11.167 0 012.652-2.569c1.024-.698 2.094-1.247 3.109-1.861.504-.3.986-.636 1.442-1.005a6.3 6.3 0 001.229-1.303 5.608 5.608 0 01-.931 1.563 9.06 9.06 0 01-1.368 1.238c-.987.745-2.048 1.322-3.025 1.973a13.094 13.094 0 00-2.68 2.28 14.14 14.14 0 00-2.066 2.941z"
                                        fill="#915548"
                                    />
                                    <Path
                                        id="Vector_32"
                                        d="M107.48 68.36a6.05 6.05 0 012.085 1.218 6.284 6.284 0 012.169 4.216 5.464 5.464 0 01-.308 2.299 10.358 10.358 0 00-.223-2.29 8.353 8.353 0 00-.744-2.103 8.436 8.436 0 00-1.257-1.861 9.557 9.557 0 00-1.722-1.48z"
                                        fill="#915548"
                                    />
                                </G>
                            </G>
                            <G id="pressable_leftForearm">
                                <Path
                                    id="highlight_leftForarm"
                                    d="M104.547 80.266l.843 5.73s2.139 22.123 3.15 26.842c1.011 4.718 3.722 9.153 3.722 9.153s8.064-2.819 10.772-4.805c2.347-1.625 5.507-3.986 7.007-6.486-1.946-7.757-4.967-13.435-8.359-25.458l-2.5-8-14.635 3.024z"
                                    fill="#A430FF"
                                    fillOpacity={0.25}
                                    stroke="#A430FF"
                                    strokeWidth={1.5}
                                    opacity={highlightedParts.includes(BODY_PARTS.forearm) ? 1 : 0}
                                />
                            </G>
                        </G>
                        <G id="pressable_leftArmpit">
                            <Path
                                id="highlight_leftArmpit"
                                d="M165.794 80.737c0 6.075-5.001 11.013-11.185 11.013s-11.185-4.938-11.185-11.013c0-6.074 5.001-11.011 11.185-11.011s11.185 4.937 11.185 11.011z"
                                fill="#A430FF"
                                fillOpacity={0.25}
                                stroke="#A430FF"
                                opacity={highlightedParts.includes(BODY_PARTS.armpit) ? 1 : 0}
                            />
                        </G>
                        <G id="pressable_leftHand">
                            <G id="leftHand">
                                <Path
                                    id="Vector_33"
                                    d="M128.913 48.616c-3.304-2.308-7.073 3.648-7.063 6.403a3.37 3.37 0 01-1.117 2.54 9.864 9.864 0 01-1.713 1.704 15.819 15.819 0 01-1.572-4.877c-.187-1.712-.978-11.642-1.117-14.676-.084-1.722-.512-2.904-1.322-3.592a2.647 2.647 0 00-2.047-.614c-2.587.279-2.587 3.722-2.587 5.193 0 1.86-.084 6.775-.149 9.613-1.052-3.61-3.62-12.703-4.142-14.118-1.247-3.36-3.052-3.639-4.355-3.285-2.792.763-2.075 3.788-1.796 4.923.363 1.545 3.769 13.625 4.318 15.765a.448.448 0 01-.102.14c-.373-.652-1.257-2.318-2.187-4.076-3.193-5.426-4.654-11.233-8.525-9.381-.93.54-1.861 1.861-.726 4.811.54 1.461 5.026 11.028 5.863 12.536a.59.59 0 010 .065c-.633-.791-1.74-2.243-2.792-3.555-2.382-2.792-3.806-6.393-7.12-4.411-1.414 1.238-.25 3.443.131 4.169.754 1.452 4.728 7.445 5.686 8.767 2.122 3.238 2.494 6.319 3.974 9.548 1.229 3.62 3.267 7.976 8.069 8.376 2.354 0 4.346-4.011 5.351-4.653 1.861.26 4.532 2.02 6.301.986a8.804 8.804 0 002.791-2.317 46.013 46.013 0 003.825-7.064 33.306 33.306 0 011.275-4.132c.884-2.038 1.936-4.141 2.15-6.328.214-1.789.675-3.54 1.368-5.203a2.795 2.795 0 00-.67-3.257z"
                                    fill="#915548"
                                />
                                <Path
                                    id="Vector_34"
                                    d="M128.532 51.334a20.305 20.305 0 00-1.471 5.584c-.195 1.991-1.219 4.048-2.057 5.974a33.734 33.734 0 00-1.321 4.226 45.88 45.88 0 01-3.676 6.793c-.987 1.47-5.323 4.011-7.939 3.276-.493.41-4.243 2.96-6.793 2.01a8.691 8.691 0 01-4.812-5.062c-.651-1.796-2.122-5.296-3.043-8.134a14.836 14.836 0 00-1.992-4.04c-.93-1.283-4.876-7.258-5.583-8.608-.708-1.349-.931-2.242-.428-2.708a1.945 1.945 0 012.559.568c.837.93 5.165 6.738 6.058 7.761.521.596 1.108.159 1.433-.465a1.48 1.48 0 00.14-1.312c-.456-.707-5.267-10.926-5.844-12.47-.512-1.369-.661-2.57 0-3.193.076-.08.164-.15.26-.205.93-.511 1.796-.065 2.634 1.099.838 1.163 5.844 10.85 6.617 12.098.437.744 1.145.568 1.638.121a1.418 1.418 0 00.502-1.191c-.195-.93-3.899-14.025-4.346-15.886-.419-1.722-.437-2.95.67-3.425l.298-.103c1.415-.39 2.317.829 2.96 2.57.642 1.74 4.299 14.824 4.653 15.922a.763.763 0 00.34.494.764.764 0 00.59.102.854.854 0 00.764-.605c.065-.512.214-9.446.214-11.82 0-2.372.297-3.787 1.405-4.01a.24.24 0 01.139 0c1.201-.112 1.945.865 2.048 3.099.149 3.062.931 12.945 1.126 14.75a15.13 15.13 0 001.303 4.393c.27.633.586 1.322.93 2.085a11.161 11.161 0 002.96-2.531 4.703 4.703 0 001.508-3.407 7.7 7.7 0 013.21-5.388c.857-.596 1.527-.512 1.945-.158a1.613 1.613 0 01.401 1.796z"
                                    fill="url(#paint19_linear_5385_8392)"
                                />
                                <Path
                                    id="Vector_35"
                                    style={{
                                        mixBlendMode: 'darken',
                                    }}
                                    d="M110.691 53.157a.212.212 0 01-.13 0 .853.853 0 00.763-.605c.065-.512.214-9.446.214-11.819 0-2.373.298-3.788 1.405-4.011-.521.27-.931 2.447-.931 5.965.075 3.816-.214 7.446-.214 8.488 0 1.042-.242 1.908-1.107 1.982z"
                                    fill="url(#paint20_linear_5385_8392)"
                                />
                                <Path
                                    id="Vector_36"
                                    style={{
                                        mixBlendMode: 'darken',
                                    }}
                                    d="M128.178 49.509c-.996-.103-2.364 1.172-3.294 2.568a7.933 7.933 0 00-1.294 3.955 9.308 9.308 0 01-2.662 4.393c-1.014.791-3.238 1.806-4.653 2.792-1.415.987-4.03 3.667-4.532 5.035-.149-3.378 2.298-6.04 4.029-7.557a14.607 14.607 0 001.862-1.806c.27.633.586 1.322.93 2.085a11.161 11.161 0 002.96-2.531 4.702 4.702 0 001.507-3.406 7.719 7.719 0 013.211-5.389c.838-.549 1.508-.493 1.936-.14z"
                                    fill="url(#paint21_linear_5385_8392)"
                                />
                                <Path
                                    id="Vector_37"
                                    d="M96.871 61.859a16.238 16.238 0 012.885-4.42 13.954 13.954 0 014.328-3.146 17.196 17.196 0 015.146-1.406c.877-.105 1.76-.154 2.643-.148.884 0 1.768.065 2.643.14-.875.064-1.749.195-2.615.297-.865.102-1.712.242-2.559.41a22.691 22.691 0 00-4.914 1.47 14.829 14.829 0 00-4.253 2.792 20.84 20.84 0 00-3.304 4.01z"
                                    fill="#915548"
                                />
                                <Path
                                    id="Vector_38"
                                    d="M111.836 67.52a10.72 10.72 0 011.638-3.258 11.167 11.167 0 012.652-2.569c1.024-.698 2.094-1.247 3.109-1.861.504-.3.986-.636 1.442-1.005a6.3 6.3 0 001.229-1.303 5.608 5.608 0 01-.931 1.563 9.06 9.06 0 01-1.368 1.238c-.987.745-2.048 1.322-3.025 1.973a13.094 13.094 0 00-2.68 2.28 14.14 14.14 0 00-2.066 2.941z"
                                    fill="#915548"
                                />
                                <Path
                                    id="Vector_39"
                                    d="M107.48 68.36a6.05 6.05 0 012.085 1.218 6.284 6.284 0 012.169 4.216 5.464 5.464 0 01-.308 2.299 10.358 10.358 0 00-.223-2.29 8.353 8.353 0 00-.744-2.103 8.436 8.436 0 00-1.257-1.861 9.557 9.557 0 00-1.722-1.48z"
                                    fill="#915548"
                                />
                            </G>
                            <G id="highlight_palm" fill="#A430FF" opacity={highlightedParts.includes(BODY_PARTS.hand) ? 1 : 0}>
                                <Path
                                    d="M99.6 75.701c1.016 2.305 2.16 3.979 4.828 4.637 0 0 2.105.266 3.544-.114 1.351-.356 4.147-2.4 4.147-2.4l6.171-.309c2.952-1.537 5.654-4.948 6.776-7.96l3.317-9.66s.32-2.96 1.246-5.597c.493-1.403.784-2.668.784-2.668.319-3.683-2.459-4.605-4.786-3.295-3.082 1.735-4.169 4.339-4.315 8.003l-1.961 2.275-1.334-4.237-.978-15.834c-.121-3.545-6.633-5.507-6.5 0v12.5l-4.5-16.5c-1.674-4.096-8.03-2.448-6.5 2.5l5 17-6-11.5c-2-4.5-9.081-3.78-5.5 3.5l6 12-6.5-8c-2.061-2.649-6.576-.189-4.356 3.998l7.123 10.928c1.648 4.927 2.418 6.483 4.293 10.733z"
                                    fillOpacity={0.25}
                                />
                                <Path d="M104.428 80.338l-.18.728.042.01.044.006.094-.744zm-4.829-4.637l-.686.303.686-.303zm-4.293-10.733l.711-.237-.03-.092-.053-.08-.628.41zM88.183 54.04l-.663.352.016.03.019.028.628-.41zm4.356-3.998l-.591.46.004.006.005.006.583-.472zm6.5 8l-.582.472a.75.75 0 001.253-.808l-.67.336zm-6-12l-.672.33.002.005.67-.335zm5.5-3.5l-.685.304.01.022.01.02.665-.346zm6 11.5l-.665.346a.75.75 0 001.385-.558l-.72.212zm-5-17l.72-.212-.003-.01-.716.222zm6.5-2.5l.724-.198-.012-.044-.017-.042-.695.284zm4.5 16.5l-.723.197a.75.75 0 001.473-.197h-.75zm0-12.5h.75V38.524l-.75.018zm6.5 0l-.749.025v.01l.001.01.748-.045zm.978 15.834l-.749.046.006.092.028.087.715-.225zm1.334 4.237l-.716.225.405 1.284.879-1.02-.568-.49zm1.961-2.275l.568.49a.75.75 0 00.182-.46l-.75-.03zm4.315-8.003l.368.653-.368-.653zm4.786 3.295l.731.169.012-.052.005-.052-.748-.065zm-.784 2.668l.708.248-.708-.248zm-1.246 5.596l.71.244.027-.08.009-.083-.746-.08zm-3.317 9.66l.703.262.003-.01.003-.008-.709-.244zm-6.776 7.961l.038.75.163-.009.146-.076-.347-.665zm-6.171.31l-.037-.75-.224.011-.181.133.442.605zm-4.147 2.4l-.191-.726.191.725zm-3.365-.615c-1.201-.297-2.025-.81-2.668-1.489-.658-.694-1.156-1.595-1.654-2.722l-1.372.605c.52 1.177 1.101 2.266 1.937 3.148.85.899 1.932 1.552 3.398 1.914l.359-1.456zm-4.322-4.211c-1.876-4.254-2.633-5.78-4.268-10.668l-1.422.475c1.66 4.965 2.444 6.55 4.318 10.798l1.372-.605zm-4.35-10.84L88.81 53.63l-1.256.819 7.123 10.928 1.256-.82zm-7.09-10.87c-.963-1.818-.408-3.051.352-3.605.813-.592 1.992-.556 2.75.418l1.184-.921c-1.303-1.674-3.412-1.732-4.817-.71-1.457 1.061-2.05 3.151-.793 5.52l1.325-.702zm3.112-3.175l6.5 8 1.165-.945-6.5-8-1.165.945zm7.753 7.192l-6-12-1.341.671 6 12 1.341-.67zm-5.998-11.995c-.858-1.744-1.018-2.982-.868-3.782.142-.758.566-1.168 1.09-1.343 1.138-.382 3.046.293 3.92 2.26l1.37-.609c-1.125-2.533-3.758-3.747-5.766-3.074-1.048.352-1.848 1.206-2.089 2.49-.233 1.242.064 2.824.998 4.72l1.345-.662zm4.162-2.822l6 11.5 1.33-.694-6-11.5-1.33.694zm7.385 10.941l-5-17-1.44.423 5.001 17 1.439-.423zm-5.003-17.01c-.334-1.08-.218-1.903.084-2.488.307-.592.842-1.013 1.478-1.218 1.277-.412 2.855.067 3.527 1.711l1.389-.567c-1.002-2.451-3.439-3.197-5.376-2.572-.971.314-1.843.977-2.35 1.957-.511.988-.616 2.226-.185 3.62l1.433-.443zm5.06-2.081l4.5 16.5 1.447-.395-4.5-16.5-1.447.395zm5.973 16.303v-12.5h-1.5v12.5h1.5zm0-12.519c-.03-1.235.314-1.902.695-2.246.385-.347.945-.486 1.598-.388 1.379.208 2.663 1.367 2.708 2.678l1.499-.051c-.076-2.234-2.109-3.828-3.983-4.11-.973-.147-2.024.034-2.826.757-.806.726-1.227 1.879-1.19 3.397l1.499-.037zm5.002.065l.977 15.834 1.497-.092-.977-15.835-1.497.093zm1.011 16.013l1.333 4.237 1.431-.45-1.334-4.237-1.43.45zm2.617 4.502l1.961-2.276-1.136-.98-1.961 2.276 1.136.98zm2.143-2.736c.07-1.77.366-3.219.975-4.414.601-1.181 1.533-2.163 2.958-2.965l-.735-1.307c-1.658.933-2.811 2.122-3.56 3.592-.742 1.456-1.062 3.142-1.137 5.035l1.499.06zm3.933-7.379c1.007-.566 1.998-.588 2.652-.223.609.34 1.162 1.152 1.019 2.8l1.495.13c.176-2.035-.502-3.525-1.783-4.24-1.237-.689-2.798-.517-4.118.226l.735 1.307zm4.418 2.642l-.73-.169-.001.003-.002.009-.009.04-.039.155a27.692 27.692 0 01-.711 2.381l1.416.497a28.97 28.97 0 00.792-2.684l.011-.046a.092.092 0 01.003-.012l.001-.004v-.001l-.731-.169zm-1.492 2.42c-.481 1.37-.801 2.81-1 3.9a31.233 31.233 0 00-.282 1.853l-.001.008v.002l.745.081.746.081.001-.006.002-.023.011-.093a29.08 29.08 0 01.253-1.633c.192-1.05.495-2.406.941-3.674l-1.416-.497zm-1.247 5.6l-3.318 9.66 1.419.488 3.318-9.66-1.419-.487zm-3.311 9.643c-1.068 2.869-3.658 6.12-6.419 7.557l.693 1.33c3.143-1.636 5.957-5.207 7.132-8.364l-1.406-.523zm-6.11 7.473l-6.171.31.075 1.497 6.171-.309-.075-1.498zm-6.134 1.058l-.442-.605h-.002l-.005.005-.022.016-.088.063-.327.23a34 34 0 01-1.085.726c-.425.272-.883.55-1.311.779-.44.235-.806.395-1.056.461l.382 1.45c.425-.111.916-.34 1.381-.588.475-.255.97-.555 1.413-.839a36.438 36.438 0 001.476-1l.094-.067.025-.018.007-.005.002-.002h.001l-.443-.606zm-4.338 1.675c-.614.162-1.414.193-2.101.175a14.28 14.28 0 01-1.141-.078l-.015-.002a.03.03 0 00-.003 0l-.093.744-.094.744h.003a.07.07 0 00.006.001l.021.003.076.008c.066.007.159.017.275.027.231.02.554.042.925.052.726.02 1.698-.006 2.523-.223l-.382-1.45z" />
                            </G>
                        </G>
                    </G>
                    <G id="pressable_leftElbow">
                        <Path
                            id="highlight_leftElbow"
                            d="M133.484 129.646c0 4.792-4.039 8.708-9.061 8.708-5.023 0-9.062-3.916-9.062-8.708s4.039-8.709 9.062-8.709c5.022 0 9.061 3.917 9.061 8.709z"
                            fill="#A430FF"
                            fillOpacity={0.25}
                            stroke="#A430FF"
                            opacity={highlightedParts.includes(BODY_PARTS.elbow) ? 1 : 0}
                        />
                    </G>
                </G>
                <G id="Group 27714">
                    <G id="Group_2">
                        <G
                            id="Ellipse 83_2"
                            transform="rotate(150 157.705 80.933)"
                            fill="#fff"
                        >
                            <Circle cx={157.705} cy={80.9329} r={2} />
                            <Circle cx={157.705} cy={80.9329} r={2} />
                        </G>
                        <Path
                            id="Line 78_2"
                            stroke="#fff"
                            d="M157.148 25.9407L157.148 80.5709"
                        />
                    </G>
                    <G id="pressableContainerSelected_armpit">
                        <BodyPartSvgButton
                            type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                            bodyPart={BODY_PARTS.armpit}
                            onPress={onPress}
                            onActivate={setActive}
                            activateAsSelect
                            x={126}
                            y={0}
                            width={65}
                            height={32}
                        />
                    </G>
                </G>
                <G id="Group 27715">
                    <G id="Group_3">
                        <G
                            id="Ellipse 83_3"
                            transform="matrix(-.48722 -.87328 .85845 -.5129 122.236 133.881)"
                            fill="#fff"
                        >
                            <Ellipse cx={1.98338} cy={1.94973} rx={1.98338} ry={1.94973} />
                            <Ellipse cx={1.98338} cy={1.94973} rx={1.98338} ry={1.94973} />
                        </G>
                        <Path
                            id="Line 78_3"
                            stroke="#fff"
                            d="M122.799 194.136L122.799 130.092"
                        />
                    </G>
                    <G id="pressableContainerSelected_elbow">
                        <G id="pressableButton_elbow">

                            <BodyPartSvgButton
                                type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                                bodyPart={BODY_PARTS.elbow}
                                onPress={onPress}
                                onActivate={setActive}
                                activateAsSelect
                                x={90}
                                y={172}
                                width={65}
                                height={32}

                            />
                        </G>
                    </G>
                </G>
                <G id="Group 27716">
                    <G id="Group_4">
                        <G
                            id="Ellipse 83_4"
                            transform="rotate(-81.787 113.773 98.717)"
                            fill="#fff"
                        >
                            <Circle cx={113.773} cy={98.7167} r={2} />
                            <Circle cx={113.773} cy={98.7167} r={2} />
                        </G>
                        <Path
                            id="Line 78_4"
                            stroke="#fff"
                            d="M53.3031 149.134L114.388 97.7282"
                        />
                    </G>
                    <G id="pressableContainerSelected_forearm">
                        <G id="pressableButton_forearm">
                            <BodyPartSvgButton
                                type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                                bodyPart={BODY_PARTS.forearm}
                                onPress={onPress}
                                onActivate={setActive}
                                activateAsSelect
                                x={2.5}
                                y={144.5}
                                width={86}
                                height={32}
                            />
                        </G>
                    </G>
                </G>
                <G id="Group 27711">
                    <G id="Group">
                        <G
                            id="Ellipse 83"
                            transform="rotate(15 103.158 62.464)"
                            fill="#fff"
                        >
                            <Circle cx={103.158} cy={62.4639} r={2} />
                            <Circle cx={103.158} cy={62.4639} r={2} />
                        </G>
                        <Path
                            id="Line 78"
                            stroke="#fff"
                            d="M36.3418 62.5614L103.252 62.5614"
                        />
                    </G>
                    <G id="pressableArea_hand">
                        {active !== BODY_PARTS.hand ?
                            <G id="pressableButton_hand">
                                <BodyPartSvgButton
                                    type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                                    bodyPart={BODY_PARTS.hand}
                                    onPress={onPress}
                                    onActivate={setActive}
                                    x={3.7}
                                    y={48}
                                    width={61}
                                    height={32}
                                />
                            </G>
                            :
                            <G id="pressable_containerSelected_hand">
                                <G id="pressableSelect_hand">
                                    <BodyPartSvgButton
                                        type={BODY_PARTS_SVG_BUTTON_TYPES.select}
                                        bodyPart={BODY_PARTS.hand}
                                        onPress={onPress}
                                        onActivate={setActive}
                                        activateAsSelect
                                        x={0.736328}
                                        y={82.9871}
                                        width={67.9961}
                                        height={46.3878}
                                    />
                                </G>
                                <G id="pressableEnlarge_hand">
                                    <BodyPartSvgButton
                                        type={BODY_PARTS_SVG_BUTTON_TYPES.enlarge}
                                        bodyPart={BODY_PARTS.hand}
                                        onPress={onPress}
                                        onActivate={setActive}
                                        activateAsSelect
                                        x={0.736328}
                                        y={44.9871}
                                        width={68}
                                        height={38}
                                    />
                                </G>
                            </G>
                        }
                    </G>
                </G>
            </G>
            <Defs>
                <LinearGradient
                    id="paint0_linear_5385_8392"
                    x1={185.881}
                    y1={139.84}
                    x2={176.295}
                    y2={74.3793}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C48054" />
                    <Stop offset={0.608984} stopColor="#E8A979" />
                    <Stop offset={1} stopColor="#D18B63" />
                </LinearGradient>
                <LinearGradient
                    id="paint1_linear_5385_8392"
                    x1={161.104}
                    y1={77.1099}
                    x2={161.104}
                    y2={147.364}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#DB9469" />
                    <Stop offset={0.927083} stopColor="#DE986B" />
                </LinearGradient>
                <LinearGradient
                    id="paint2_linear_5385_8392"
                    x1={102.238}
                    y1={123.886}
                    x2={117.547}
                    y2={102.909}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#D38D65" />
                    <Stop offset={1} stopColor="#C27852" />
                </LinearGradient>
                <LinearGradient
                    id="paint3_linear_5385_8392"
                    x1={155.843}
                    y1={158.18}
                    x2={93.9547}
                    y2={67.1909}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint4_linear_5385_8392"
                    x1={98.8534}
                    y1={77.7302}
                    x2={112.456}
                    y2={57.4709}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#BA704A" />
                    <Stop offset={1} stopColor="#C58457" />
                </LinearGradient>
                <LinearGradient
                    id="paint5_linear_5385_8392"
                    x1={86.52}
                    y1={52.0497}
                    x2={101.987}
                    y2={50.2164}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint6_linear_5385_8392"
                    x1={94.2535}
                    y1={45.0888}
                    x2={108.865}
                    y2={45.3494}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint7_linear_5385_8392"
                    x1={86.9657}
                    y1={69.4049}
                    x2={107.552}
                    y2={63.1137}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint8_linear_5385_8392"
                    x1={105.671}
                    y1={43.7456}
                    x2={118.254}
                    y2={47.8777}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint9_linear_5385_8392"
                    x1={117.063}
                    y1={49.2918}
                    x2={122.703}
                    y2={69.2263}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint10_linear_5385_8392"
                    x1={141.459}
                    y1={114.111}
                    x2={128.888}
                    y2={106.48}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#BE734E" />
                    <Stop offset={1} stopColor="#D28C64" />
                </LinearGradient>
                <LinearGradient
                    id="paint11_linear_5385_8392"
                    x1={102.148}
                    y1={123.023}
                    x2={117.457}
                    y2={102.046}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#D38D65" />
                    <Stop offset={1} stopColor="#C27852" />
                </LinearGradient>
                <LinearGradient
                    id="paint12_linear_5385_8392"
                    x1={155.753}
                    y1={157.317}
                    x2={93.8648}
                    y2={66.3281}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint13_linear_5385_8392"
                    x1={86.4302}
                    y1={51.187}
                    x2={101.897}
                    y2={49.3536}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint14_linear_5385_8392"
                    x1={94.1636}
                    y1={44.226}
                    x2={108.775}
                    y2={44.4866}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint15_linear_5385_8392"
                    x1={86.8758}
                    y1={68.5421}
                    x2={107.462}
                    y2={62.2509}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint16_linear_5385_8392"
                    x1={98.7636}
                    y1={76.8675}
                    x2={112.366}
                    y2={56.6081}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#BA704A" />
                    <Stop offset={1} stopColor="#C58457" />
                </LinearGradient>
                <LinearGradient
                    id="paint17_linear_5385_8392"
                    x1={105.582}
                    y1={42.8828}
                    x2={118.164}
                    y2={47.0149}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint18_linear_5385_8392"
                    x1={116.973}
                    y1={48.429}
                    x2={122.613}
                    y2={68.3635}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint19_linear_5385_8392"
                    x1={98.7636}
                    y1={76.8675}
                    x2={112.366}
                    y2={56.6081}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#BA704A" />
                    <Stop offset={1} stopColor="#C58457" />
                </LinearGradient>
                <LinearGradient
                    id="paint20_linear_5385_8392"
                    x1={105.582}
                    y1={42.8828}
                    x2={118.164}
                    y2={47.0149}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <LinearGradient
                    id="paint21_linear_5385_8392"
                    x1={116.973}
                    y1={48.429}
                    x2={122.613}
                    y2={68.3635}
                    gradientUnits="userSpaceOnUse"
                >
                    <Stop stopColor="#C97551" />
                    <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
                </LinearGradient>
                <ClipPath id="clip0_5385_8392">
                    <Path
                        fill="#fff"
                        transform="translate(79.904 26.226)"
                        d="M0 0H104V112H0z"
                    />
                </ClipPath>
            </Defs>
        </Svg>
    );
}

export { BodyTypesSVG_arm };
